import React,{useState} from 'react';
import education from '../../assets/icon/education.svg';
import skills from '../../assets/icon/skills.svg';
import experienc from '../../assets/icon/experience.svg';
import projects from '../../assets/icon/projects.svg';
import contact from '../../assets/icon/contact.svg';
import Education from './education';
import Skills from './skills';
import Projects from './projects';
import Experience from './experience';
import Contact from './contact';
import {Drawer, Button} from '@material-ui/core';
import {Fade} from 'react-awesome-reveal';
import {useTranslation} from 'react-i18next';

export default function All() {

  const [comp,setcomp]=useState("");

  const [open,setopen]=useState(false);

  const {t,i18n} = useTranslation();


const openwindow=(component)=>{
  setopen(true);
  setcomp(component);
}

const ChangeComponent=(comp)=>{
  switch(comp){
    case  "education":
      return <Education/> 
    case "skills":
       return <Skills/>
    case "experience":
      return <Experience/>
    case "projects":
      return <Projects/>
    default :
    return <Contact/>
  
      }
}

  return (
    <main>
    <div className="row-3">
    <Fade cascade>
    <h3>{t('howitworks.label')}</h3><br/>
    <p classNmae="texthowitworks">{t('howitworkstext.label')}</p>
    </Fade>
    </div>
    <div className="row-1">
    <div>
    <img onClick={()=>{openwindow("education")}} src={education} width="60" />
    Education
    </div>
    <div>
    <img onClick={()=>openwindow("experience")} src={experienc} width="60" />
    Experience
    </div>
    <div>
    <img onClick={()=>openwindow("skills")} src={skills} width="60" />
    {t('skills.label')}
    </div>
    </div>
    <div className="row-2">
    <div>
    <img onClick={()=>openwindow("projects")} src={projects} width="60" />
    {t('projects.label')}
    </div>
    <div>
    <img onClick={()=>openwindow("contact")} src={contact} width="60" />
    Direct contact
    </div>
    </div>
    <React.Fragment >
    <Drawer id="drawer" anchor="top" open={open} onClose={()=>setopen(false)}>
          {open===true ? ChangeComponent(comp) : <p>empty</p>}
          <Button onClick={()=>setopen(false)} color="primary" variant="contained">Close</Button>
    </Drawer>
    </React.Fragment>
    </main>
  );
}
